
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as HistoricalIconComponent } from "./historical-icon.svg";

export const HistoricalIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <HistoricalIconComponent {...props} />;
};
